import * as types from './constants';
import { sections } from './sections';

const initialState = {
	sections: sections
};

const actions = {
	[types.TOGGLE_SECTION]: (state, { payload }) => {


		const data = {
			...state,
			sections: state.sections.map(section => section.key === payload.key ? { ...section, open: !section.open } : section)
		};

		return { ...data };
	}
};

export default (state = initialState, action) => {
	if (actions[action.type]) return actions[action.type](state, action);
	return state;
};
